<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'expanded-menu.expiration-period'">Plazo de expiración</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <p class="common-modal__content-header-info"
      [afTranslate]="'expiration-period.expiration-info'">La encuesta será accesible desde el momento de difusión hasta la fecha de expiración. Este plazo podrá ser reducido o ampliado en cualquier momento.</p>
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-date [field]="expirationPeriod.repeatIntervalDate"
        [preSelectItem]="expirationPeriod.intervalRepeat.startInterval"
        (itemSelected)="selectIntervalDate('startInterval', $event)"></field-type-date>
      <div class="common-radio-button-list__container">
        <div class="common-radio-button-list__container-box"
          [ngClass]="{'common-radio-button-list__container-box--error': expirationPeriod.hasError}">
          <div class="common-text-input__block-header">
            <p class="common-text-input__label">
              <span class="common-text-input__text-label"
                [afTranslate]="'repeat-pattern.end-interval'">
              </span>
              <span class="common-tag__mandatory-text-asterisk">*</span>
            </p>
          </div>
          <label for="no-end-date"
            class="common-radio-button-list__switch-option-container">
            <input type="radio"
              class="common-radio-button__no-input"
              id="no-end-date"
              name="select-interval-expiration"
              value="no-end-date"
              [(ngModel)]="expirationPeriod.intervalRepeat.selectInterval">
              <div class="common-radio-button__size-sm">
                <i class="common-icon__sm"
                  [ngClass]="expirationPeriod.intervalRepeat.selectInterval === 'no-end-date'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
                </i>
              </div>
              <span class="common-radio-button-list__switch-option-text capitalize"
                [afTranslate]="'expiration-period.no-end-date'">_Sin fecha de expiración</span>
          </label>
          <label for="end-interval-day"
            class="common-radio-button-list__switch-option-container">
            <input type="radio"
              id="end-interval-day"
              class="common-radio-button__no-input"
              type="radio"
              name="select-interval-expiration"
              value="end-interval-day"
              [(ngModel)]="expirationPeriod.intervalRepeat.selectInterval">
            <div class="common-radio-button__size-sm">
              <i class="common-icon__sm"
                [ngClass]="expirationPeriod.intervalRepeat.selectInterval === 'end-interval-day'?'lf-icon-radio-button-active common-radio-button__select-main':'lf-icon-step-first common-radio-button__un-select-grey'">
              </i>
            </div>
            <span class="common-radio-button-list__switch-option-text"
              [afTranslate]="'expiration-period.expirated-day'">_expirar encuesta el día</span>
              <picker-data-simple
                [finishIntervalDate]="expirationPeriod.intervalRepeat.finishIntervalDate"
                (selectDate)="selectIntervalDate($event, 'finishIntervalDate')"
                [disabled]="expirationPeriod.intervalRepeat.selectInterval !== 'end-interval-day'">
              </picker-data-simple>
          </label>
        </div>
        @if(expirationPeriod.hasError){
          <div class="common-text-input__mandatory-tag">
            <span>{{expirationPeriod.textError}}</span>
          </div>
        }
      </div>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="validateRepetition()">
      <span class="common-button__text-title"
        [afTranslate]="'common.save'">Guardar</span>
    </button>
  </div>
</div>
